"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.applySteps = applySteps;

var _reduxActions = require("redux-actions");

var _constants = require("./constants");

var C = _interopRequireWildcard(_constants);

var _auth = require("../../../reducers/auth");

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _AppDataField = require("./AppDataField");

var _DrawAppDataField = require("./fields/DrawAppDataField");

var _DrawAppDataField2 = _interopRequireDefault(_DrawAppDataField);

var _ImageAppDataField = require("./fields/ImageAppDataField");

var _ImageAppDataField2 = _interopRequireDefault(_ImageAppDataField);

var _TableAppDataField = require("./fields/TableAppDataField");

var _TableAppDataField2 = _interopRequireDefault(_TableAppDataField);

var _TableNoColumnsAppDataField = require("./fields/TableNoColumnsAppDataField");

var _TableNoColumnsAppDataField2 = _interopRequireDefault(_TableNoColumnsAppDataField);

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _tcombValidation = require("tcomb-validation");

var _tcombValidation2 = _interopRequireDefault(_tcombValidation);

var _DataField = require("../../../cms/reducers/designer/CMSReport/DataField");

var DataField = _interopRequireWildcard(_DataField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    selectedReport: null,
    selectedReportDefinition: null,
    reportData: [],
    contingent: 0,
    reportStepData: [],
    typeReferences: [],
    saveReportDataPromiseState: null,
    isSynchronized: true
};
function handleReport(report, reportDefinition, saveReportDataPromiseState, contingent) {
    var reportData = reportEntriesForReportDefinitionTypes(report, reportDefinition);
    var newState = {
        selectedReport: report,
        selectedReportDefinition: reportDefinition,
        reportData: reportData,
        contingent: contingent,
        typeReferences: report.data.typeReferences,
        saveReportDataPromiseState: saveReportDataPromiseState,
        reportStepData: reportFieldsForReportDefinition(report, reportDefinition, reportData),
        isSynchronized: true // new input from remote received - hence now synchronized!
    };
    return newState;
}
exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, C.REPORTDETAILS_REPORT_CONTINGENT_SUCCESS, function (state, action) {
    var newState = (0, _lodash.cloneDeep)(state);
    var contingent = (0, _selectn2.default)("value.availableContingent", action.payload);
    newState.contingent = contingent;
    return newState;
}), _defineProperty(_handleActions, C.REPORTDETAILS_REPORTSTEP_VALIDATION_CHANGED, function (state, action) {
    var newState = (0, _lodash.cloneDeep)(state);
    newState.reportStepData = (0, _lodash.chain)(newState.reportStepData).map(function (reportStepData) {
        if (reportStepData.stepDefinition.uid === action.payload.stepDefinition.uid) {
            return action.payload;
        } else {
            return reportStepData;
        }
    }).value();
    return newState;
}), _defineProperty(_handleActions, C.REPORTDETAILS_UPDATE_DISMISS_ERROR, function (state, action) {
    return Object.assign({}, state, {
        saveReportDataPromiseState: { value: null }
    });
}), _defineProperty(_handleActions, C.REPORTDETAILS_SELECT_REPORT, function (state, action) {
    return handleReport(action.payload.selectedReport, action.payload.selectedReportDefinition, state.saveReportDataPromiseState, state.contingent);
}), _defineProperty(_handleActions, C.REPORTDETAILS_UPDATE_REPORT, function (state, action) {
    return Object.assign({}, state, {
        saveReportDataPromiseState: action.payload
    });
}), _defineProperty(_handleActions, C.REPORTDETAILS_UPDATE_REPORT_FAILED, function (state, action) {
    return Object.assign({}, state, {
        saveReportDataPromiseState: action.payload
    });
}), _defineProperty(_handleActions, C.REPORTDETAILS_UPDATE_REPORT_SUCCESS, function (state, action) {
    if (state.selectedReport !== null && action.payload.value.uid === state.selectedReport.uid) {
        return handleReport(action.payload.value, state.selectedReportDefinition, action.payload, state.contingent);
    }
    return state;
}), _defineProperty(_handleActions, C.REPORTDETAILS_UPDATE_REPORT_APP_DATA_FIELD, function (state, action) {
    // search for the given app data field and update the content of the reducers app data field
    var newState = (0, _lodash.cloneDeep)(state);
    if (action.payload) {
        var currentReportStepData = newState.reportStepData;
        var newReportStepData = (0, _lodash.chain)(currentReportStepData).map(function (stepData) {
            stepData.fields = (0, _lodash.chain)(stepData.fields).map(function (fieldData) {
                if (fieldData.appDataField.key() === action.payload.key()) {
                    fieldData.appDataField = action.payload.copy();
                }
                return fieldData;
            }).value();
            return stepData;
        }).value();
        return Object.assign({}, newState, {
            reportStepData: newReportStepData,
            isSynchronized: false
        });
    }
    return newState;
}), _defineProperty(_handleActions, C.REPORTDETAILS_UPDATE_REPORT_FORM_DATA, function (state, action) {
    // updates the current report steps data
    // expects key value pairs of a given step
    // usually this data comes from a tcomb form.
    var newState = (0, _lodash.cloneDeep)(state);
    var _action$payload = action.payload;
    var reportStepId = _action$payload.reportStepId;
    var formData = _action$payload.formData;

    if (reportStepId && formData) {
        var _ret = function () {
            var relevantReportStep = (0, _lodash.find)(newState.reportStepData, function (reportStep) {
                return reportStep.stepDefinition.uid === reportStepId;
            });
            (0, _lodash.chain)(formData).forEach(function (formValue, key) {
                (0, _lodash.chain)(relevantReportStep.fields).forEach(function (reportField) {
                    if (reportField.appDataField.key() === key) {
                        var newInstance = reportField.appDataField.copy();
                        newInstance.setValue(formValue);
                        reportField.appDataField = newInstance;
                        return false;
                    }
                }).value();
            }).value();
            var index = (0, _lodash.findIndex)(newState.reportStepData, function (stepData) {
                return stepData.stepDefinition.uid === relevantReportStep.stepDefinition.uid;
            });
            if (index) {
                var newReportStepData = newState.reportStepData;
                newReportStepData[index] = relevantReportStep;
                return {
                    v: Object.assign({}, newState, {
                        reportStepData: newReportStepData,
                        isSynchronized: false
                    })
                };
            } else {
                return {
                    v: Object.assign({}, newState, {
                        isSynchronized: false
                    })
                };
            }
        }();

        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
    }
    return state;
}), _defineProperty(_handleActions, _auth.AUTH_GLOBAL_SECURITY_ERROR, function (state, action) {
    return Object.assign({}, initialState);
}), _defineProperty(_handleActions, _auth.AUTH_LOGOUT, function (state, action) {
    return Object.assign({}, initialState);
}), _defineProperty(_handleActions, C.REPORTDETAILS_RESET, function (state, action) {
    return Object.assign({}, initialState);
}), _handleActions), initialState);

function validateStep(reportStep) {
    return (0, _lodash.chain)(reportStep.fields).map(function (reportField) {
        var schema = t.struct(reportField.appDataField.appSchemaObject(), "TempFormSchema");
        var tempValue = _defineProperty({}, reportField.appDataField.key(), reportField.appDataField.currentFormValue());
        return _tcombValidation2.default.validate(tempValue, schema).isValid();
    }).thru(function (validationResult) {
        return !(0, _lodash.includes)(validationResult, false);
    }).value();
}
function reportFieldsForReportDefinition(report, reportDefinition, reportData) {
    return (0, _lodash.chain)(reportDefinition.data.steps).map(function (step) {
        return {
            isValid: false,
            stepDefinition: step,
            fields: (0, _lodash.chain)(step.fields).filter(function (field) {
                return true;
                // return field.type === "draw" || field.type==="text";
                // return field.type ===  "text" || field.type ===  "date" || field.type === "choice" || field.type === "draw";
            }).map(function (fieldDefinition) {
                var fieldArr = (0, _lodash.chain)(report.data.fields).filter(function (field) {
                    return field.uid === fieldDefinition.properties.uid;
                }).value();
                var field = fieldArr.length > 0 ? fieldArr[0] : null;
                var dataField = DataField.DataFieldFactory.dataFieldForProps(fieldDefinition);
                var appDataField = _AppDataField.AppDataFieldFactory.appDataFieldForDataField(dataField, field, reportData);
                return {
                    fieldDefinition: fieldDefinition,
                    field: field,
                    appDataField: appDataField
                };
            }).value()
        };
    }).map(function (reportStepData) {
        reportStepData.isValid = validateStep(reportStepData);
        return reportStepData;
    }).value();
}
// typeFilters is currently unused.
function reportEntriesForReportDefinitionTypes(report, reportDefinition) {
    var typeFilters = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

    var reportDefinitionSorted = reportDefinition;
    return (0, _lodash.chain)(reportDefinition.data).map(function (data, key) {
        return {
            key: key,
            data: data
        };
    }).thru(function (values) {
        // reorder types
        var objects = (0, _lodash.find)(values, function (item) {
            return item.key === "objects";
        });
        var items = (0, _lodash.find)(values, function (item) {
            return item.key === "items";
        });
        var issues = (0, _lodash.find)(values, function (item) {
            return item.key === "issues";
        });
        var steps = (0, _lodash.find)(values, function (item) {
            return item.key === "steps";
        });
        return [objects, items, issues, steps];
    }).filter(function (item) {
        // filter steps
        if (item.key === "steps") {
            return false;
        } else {
            return (0, _lodash.chain)(typeFilters).map(function (filterValue) {
                if (filterValue) {
                    return item.key !== filterValue;
                } else {
                    return true;
                }
            }).thru(function (boolResult) {
                return !(0, _lodash.includes)(boolResult, false);
            }).value();
        }
    }).map(function (item) {
        return (0, _lodash.chain)(item.data).map(function (itemType) {
            var tempValues = Array();
            switch (item.key) {
                case "issues":
                    tempValues = report.data.issues.filter(function (reportEntity) {
                        return reportEntity.issueTypeUid === itemType.uid;
                    });
                    break;
                case "items":
                    tempValues = report.data.items.filter(function (reportEntity) {
                        return reportEntity.itemTypeUid === itemType.uid;
                    });
                    break;
                case "objects":
                    tempValues = report.data.objects.filter(function (reportEntity) {
                        return reportEntity.objectTypeUid === itemType.uid;
                    });
                    break;
            }
            return {
                dataKey: item.key,
                dataDefinition: itemType,
                dataEntries: tempValues
            };
        }).value();
    }).flatten().value();
}
function applySteps(selectedReport, reportStepData) {
    var newReport = _.cloneDeep(selectedReport);
    newReport.data.fields = _.chain(reportStepData).map(function (stepData) {
        return _.chain(stepData.fields).filter(function (field) {
            return field.appDataField.currentFormValue();
        }).map(function (field) {
            return extractContentDataField(field);
        }).value();
    }).flatten().value();
    return newReport;
}
function extractContentDataField(field) {
    var contentField = field.appDataField.contentDataField;
    // wrap single choice value into array
    if (field.appDataField instanceof _AppDataField.SingleChoiceAppDataField) {
        return transformContentDataField(contentField);
    }
    // wrap attachmentUid of drawfields into array
    if (field.appDataField instanceof _DrawAppDataField2.default) {
        return transformContentDataField(contentField);
    }
    if (field.appDataField instanceof _ImageAppDataField2.default) {
        return transformContentDataField(contentField);
    }
    if (field.appDataField instanceof _TableAppDataField2.default || field.appDataField instanceof _TableNoColumnsAppDataField2.default) {
        var rows = (0, _selectn2.default)("data.rows", contentField);
        var newRows = (0, _lodash.chain)(rows).map(function (row) {
            row.fields = (0, _lodash.chain)(row.fields).map(function (field) {
                return transformContentDataField(field);
            }).value();
            return row;
        }).value();
        _.set(contentField, "data.rows", newRows);
    }
    return contentField;
}
function transformContentDataField(contentDataField) {
    if (contentDataField.type === "choice") {
        var value = (0, _selectn2.default)("data.choices", contentDataField);
        if (!_.isArray(value)) {
            value = value ? Array(value) : value;
        }
        _.set(contentDataField, "data.choices", value);
    }
    if (contentDataField.type === "draw") {
        var _value = (0, _selectn2.default)("data.attachmentUids", contentDataField);
        if (!_.isArray(_value)) {
            _value = _value ? Array(_value) : _value;
        }
        _.set(contentDataField, "data.attachmentUids", _value);
    }
    if (contentDataField.type === "image") {
        var _value2 = (0, _selectn2.default)("data.attachmentUids", contentDataField);
        if (!_.isArray(_value2)) {
            _value2 = _value2 ? Array(_value2) : _value2;
        }
        _.set(contentDataField, "data.attachmentUids", _value2);
    }
    return contentDataField;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/index.ts
 ** module id = 641
 ** module chunks = 0
 **/